import React from 'react';
import { AlertCircle } from 'lucide-react';

interface Props {
  children: React.ReactNode;
  label?: string;
}

interface State {
  hasError: boolean;
}

/**
 * Isola un pannello del drawer (WhatsApp, AlfaDocs, ...) così un suo errore di render
 * mostra un fallback locale invece di propagare alla root e sbiancare tutta l'app.
 * Va usato con una `key` legata al tab attivo, per resettare lo stato al cambio tab.
 */
export class PanelErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('[PanelErrorBoundary] render error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex-1 flex flex-col items-center justify-center gap-2 p-6 text-center">
          <AlertCircle className="w-7 h-7 text-[#787774]" />
          <p className="text-sm text-[#787774] dark:text-gray-400">
            {this.props.label || 'Impossibile caricare questa sezione'}
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
